module.exports = __webpack_public_path__ + "static/media/badge-appstpre.c8abe434.svg";